
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rental-agreement/[[...listingId]]",
      function () {
        return require("private-next-pages/rental-agreement/[[...listingId]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rental-agreement/[[...listingId]]"])
      });
    }
  